import { get, rm, set } from "lockr";
import { AuthSession } from "./authTypes";
import { User } from "../types/common.types";

const TOKEN_KEY = "token";
const USER_KEY = "user";
const MEMBERSHIP_PLANS_KEY = "membershipPlans";
const PERMISSIONS_KEY = "staff-permissions";

const clearStoredSession = () => {
  rm(TOKEN_KEY);
  rm(USER_KEY);
  rm(MEMBERSHIP_PLANS_KEY);
  rm(PERMISSIONS_KEY);
};

export const authStorage = {
  getToken(): string | null {
    return (get(TOKEN_KEY) as string | undefined) || null;
  },

  getSession(): AuthSession | null {
    const token = get(TOKEN_KEY) as string | undefined;
    const user = get(USER_KEY) as User | undefined;

    if (!token || !user) {
      if (!token && user) clearStoredSession();
      return null;
    }

    return {
      token,
      user,
      membershipPlans: get(MEMBERSHIP_PLANS_KEY),
      permissions: get(PERMISSIONS_KEY) as string[] | undefined,
    };
  },

  saveSession(session: AuthSession) {
    set(TOKEN_KEY, session.token);
    set(USER_KEY, session.user);

    if (session.membershipPlans !== undefined) {
      set(MEMBERSHIP_PLANS_KEY, session.membershipPlans);
    } else {
      rm(MEMBERSHIP_PLANS_KEY);
    }
    if (session.permissions !== undefined) {
      set(PERMISSIONS_KEY, session.permissions);
    } else {
      rm(PERMISSIONS_KEY);
    }
  },

  updateUser(user: User) {
    set(USER_KEY, user);
  },

  clearSession() {
    clearStoredSession();
  },
};
